import colorObjects from './color.json';
import newColorObjects from './new-color.json';

export const Colors = { ...colorObjects, ...newColorObjects };
